import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChartIcon, OpinionsIcon } from '../components/Brand/Icon';
import { AnimatedLink } from '../components/Buttons/AnimatedLink';
import useStoryNavigation from '../hooks/useStoryNavigation';
import { unsubscribeCopy } from './card';
import './UnsubscribeContent.css';

export default function UnsubscribeContent({ reaction, translated, onLeaveFeed }) {
  const { t } = useTranslation();
  const [intro, closing] = unsubscribeCopy(translated ? reaction.landing_language : 'en');
  const { sectionLink } = useStoryNavigation({
    storyId: reaction.story.id, title: reaction.story.title, reactionId: reaction.id,
    entry: 'unsubscribe', onLeaveFeed,
  });
  return <section className="reaction_content_text unsubscribe-message">
    <p>{intro}</p>
    <div className="unsubscribe-message__actions" data-no-swipe>
      <AnimatedLink {...sectionLink('statistics', 'statistic')} aria-label={t('story.statistics')}>
        <ChartIcon className="nav-icon" />
      </AnimatedLink>
      <AnimatedLink {...sectionLink('opinions', 'reactions')} aria-label={t('story.opinions')}>
        <OpinionsIcon className="nav-icon" />
      </AnimatedLink>
    </div>
    <p>{closing}</p>
  </section>;
}
